import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import {
	Row,
	Col,
	Button,
	Input,
	Space,
	notification,
	Affix,
	List,
	Checkbox,
	Radio,
	Modal,
} from 'antd';
import { XLottie } from '../Login/LoginStyle';
import LoginAnimation from '../../json/Login.json';
import Thanks from '../../json/thanksNew1.json';
import {
	XContainer,
	XForm,
	XModal,
	XSelect,
	XRoundButton,
	XModalTitle,
	XModalSubtitle,
	XList,
	XCircle,
	XLabel,
} from '../../styles/GlobalThemeStyle';
import HeaderFile from '../../components/Header/HeaderFile';
import {
	XLottieMargin,
	Title,
	XPara1,
	XDivider,
	XButtonCloseBar,
	XButtonReload,
	XNotificationBar,
	XButtonConfirm,
	XCheckboxGroup,
	XuploadAddCase,
	XLottieOverlay,
} from '../AnalyseCoverage/AnalyseCoverageStyle';
import {
	PlusOutlined,
	CloseOutlined,
	PauseOutlined,
	CheckOutlined,
	AudioOutlined,
} from '@ant-design/icons';
// Actions
import {
	analyseCoverageApi,
	analyseCoverageReset,
} from '../../actions/analyseCoverageAction';
import {
	reviseCoverageApi,
	reviseCoverageReset,
} from '../../actions/reviseCoverageAction';
import {
	sendFeedbackApi,
	sendFeedbackReset,
} from '../../actions/sendFeedbackAction';
import {
	getStateDropdownApi,
	getStateDropdownReset,
} from '../../actions/getStateDropdownAction';
import Header from '../../components/Header/Header';
import { filterByLabel, handleInputChange } from '../../utils/formFunctions';
import {
	getAnalysisReset,
	getAnalysisApi,
} from '../../actions/getAnalysisAction';
import AnalysisLoader from '../../components/AnalysisLoader/AnalysisLoader';
import { checkModulePermissions } from '../../utils/helper';
import CaseOperations from '../../components/HorizontalTimeline/CaseOperations';
import { XRadio } from '../CaseForm/CaseFormStyle';
import config from '../../config';
import {
	AipaAudioBtn,
	AipaAudioCard,
	AipaCard,
	AipaOtherBtn,
	AipaPlayBtn,
} from './AipaStyle';
import {
	getAppealLetterApi,
	getAppealLetterReset,
} from '../../actions/getAppealLetterAction';
// import AppealLoading from '../../json/reloading.json';
import AppealLoading from '../../json/newAppealLetter.json';
import AppealLetter from '../../components/HorizontalTimeline/AppealLetter';
import { modelTypes } from '../../utils/constants';
const { TextArea } = Input;
const moment = require('moment');

const Aipa = (props) => {
	const {
		analyseCoverage,
		analyseCoverageReset,
		analyseCoverageState,
		reviseCoverage,
		reviseCoverageReset,
		reviseCoverageState,
		sendFeedback,
		sendFeedbackReset,
		sendFeedbackState,
		getStateDropdownState,
		getStateDropdown,
		getAnalysis,
		getAnalysisState,
		getAnalysisReset,
		getAppealLetter,
		getAppealLetterState,
	} = props;
	const missingFieldsCardRef = useRef(null);
	const [form] = XForm.useForm();
	const [formUpload] = XForm.useForm();
	const [clinicalDocsForm] = XForm.useForm();
	const [showClinicalTextArea, setShowClinicalTextArea] = useState(false);
	const [isClinicalUploadModalOpen, setIsClinicalUploadModalOpen] =
		useState(false);
	const [clinicalDocsLoading, setClinicalDocsLoading] = useState(false);
	const [clinicalDocumentFileList, setClinicalDocumentFileList] = useState(
		[],
	);
	const [submitClinicalDocs, setSubmitClinicalDocs] = useState(false); // Initial value can be 'textarea' or 'upload'
	const [formData, setFormData] = useState();
	const [clinicalSummaryTextLoading, setClinicalSummaryTextLoading] =
		useState(false);
	const [supportingDocsSummary, setSupportingDocsSummary] = useState('');
	const [pdfPreviewOpen, setPdfPreviewOpen] = useState(false);
	const [previewImage, setPreviewImage] = useState('');
	const [previewTitle, setPreviewTitle] = useState('Upload Acknowledgement');
	const [newOptionForm] = XForm.useForm();
	const [summaryForm] = XForm.useForm();
	const [loading, setLoading] = useState(false);
	const [modalOpen, setModalOpen] = useState([false, '', '', '', '']);
	const [thanksModal, setThanksModal] = useState([false, '']);
	const [summary, setSummary] = useState('');
	const [state, setState] = useState('');
	const [provider, setProvider] = useState('');
	const [modalTextArea, setModalTextArea] = useState('');
	const [feedbackId, setFeedbackId] = useState(null);
	const [pageContent, setPageContent] = useState({
		pastHistory: [],
		presentComplaint: [],
		recommendedProcedure: [],
		medicalCoverage: [],
		status: '',
		missing_points_for_coverage: [],
	});
	const [insuranceCompanies, setInsuranceCompanies] = useState([]);
	const [callGetAnalysisAPiBtn, setCallGetAnalysisAPiBtn] = useState(true);
	const [missingFieldsModal, setMissingFieldsModal] = useState(false);
	const [missingFields, setMissingFields] = useState([]);
	const [missingFieldInstructions, setMissingFieldInstructions] = useState(
		[],
	);
	const [missingFieldTitle, setMissingFieldTitle] = useState('');
	const [missingFieldsForm] = XForm.useForm();
	const [lastAnalysisData, setLastAnalysisData] = useState({});
	const [showAnalysisData, setShowAnalysisData] = useState(false);
	const [analysisCompleted, setAnalysisCompleted] = useState('');
	const [newOptionText, setNewOptionText] = useState('');
	const [newCheckBoxModal, setNewCheckBoxModal] = useState([false, null]);
	const [id, setId] = useState('');
	const [coverageloading, setCoverageLoading] = useState(false);
	const [LooksGoodLoading, setLooksGoodLoading] = useState(false);
	const [isMissingFieldsThere, setIsMissingFieldsThere] = useState(false);
	const [
		updatedClinicalDocumentFileList,
		setUpdatedClinicalDocumentFileList,
	] = useState([]);
	const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
	const [previewOpen, setPreviewOpen] = useState(false);
	const [clinicalDocumentsToDisplay, setClinicalDocumentsToDisplay] =
		useState([]);
	const [clinicalSelectedOption, setClinicalSelectedOption] =
		useState('clinical_text'); // Initial value can be 'textarea' or 'upload'
	const [supportingFiles, setSupportingFiles] = useState([]);
	const [isClinicalDocUploadFromCommon, setIsClinicalDocUploadFromCommon] =
		useState(false);
	const [isUploadClinicalDoc, setIsUploadClinicalDoc] = useState(false);
	const [appealLetterType, setAppealLetterType] = useState('');
	const [appealLetterContent, setAppealLetterContent] = useState('');
	const [showAppealLetterPreview, setShowAppealLetterPreview] =
		useState(false);
	const [appealLetterLoading, setAppealLetterLoading] = useState(false);
	const [selectedModel, setSelectedModel] = useState('');

	useEffect(() => {
		if (modalOpen[0] && modalOpen[4] !== 'feedbackSummary') {
			// Check if modal is open and it's not the feedbackSummary modal
			const [description, code] = modalTextArea.split(' - ');
			form.setFieldsValue({
				modal_text_area: description || '', // Prepopulate description
				code: code ? code.split(': ')[1] : '', // Extract and prepopulate code
			});
		}
	}, [modalOpen, modalTextArea, form]);

	useEffect(() => {
		if (
			getStateDropdownState.apiState === 'success' &&
			getStateDropdownState.data &&
			getStateDropdownState.data.all_states?.length > 0
		) {
			// Check if the field is already populated
			const currentState = summaryForm.getFieldValue('state');
			if (!currentState) {
				const preselectedState = 'Washington';
				summaryForm.setFieldValue('state', preselectedState);

				// Set insurance companies for the preselected state
				const selectedState =
					getStateDropdownState.data.all_states.find(
						(itm) => itm.state === preselectedState,
					);

				if (selectedState) {
					setState(preselectedState);
					setInsuranceCompanies(selectedState.providers);
				}
			}
		}
	}, [getStateDropdownState]);

	useEffect(() => {
		if (getAppealLetterState.apiState === 'success') {
			setAppealLetterLoading(false);
			console.log('getAppealLetterState inpl');
			// getAnalysis({ id: id });
			setAppealLetterContent(getAppealLetterState.data.appeal_letter);
			setShowAppealLetterPreview(true);
			// navigate(`/case/filings/preview/${id}`, {
			// 	state: {
			// 		appealLetterType: appealLetterType,
			// 		// id: id,
			// 		patientDetails: patientData,
			// 		content: getAppealLetterState.data.appeal_letter,
			// 		header: getAppealLetterState.data.header,
			// 		footer: getAppealLetterState.data.footer,
			// 		isEdit: false,
			// 	},
			// });
		}
		if (getAppealLetterState.apiState === 'error') {
			setAppealLetterLoading(false);
			notification.error({
				message: getAppealLetterState.message
					? getAppealLetterState.message
					: 'Unable to get Appeal Letter content',
			});
		}
		getAppealLetterReset();
	}, [getAppealLetterState.apiState]);

	const previewAppealLetter = (type, regenerate = true) => {
		getAppealLetter({
			id: id,
			type: type,
			regenerate_appeal_letter: regenerate,
			aipa: true,
			provider: provider,
			clinical_summary: summary,
			state: state,
			feedbackId: feedbackId,
		});
		setAppealLetterType(type);
	};

	const handleUploadCancel = () => {
		setIsClinicalUploadModalOpen(false);
		setIsUploadModalOpen(false);
		setClinicalDocumentFileList([]);
		setUpdatedClinicalDocumentFileList([]);
		setClinicalDocsLoading(false);
		setSubmitClinicalDocs(false);
		setFormData({
			...formData,
			clinical_summary: '',
		});

		clinicalDocsForm.setFieldsValue({ clinical_docs: '' });
	};

	const handlePreviewClinicalSummary = async (file) => {
		// Check if the file is a PDF
		if (file && file.name && file.name.split('.').includes('pdf')) {
			// If there's a URL, use it directly; otherwise, generate a preview from the file
			const fileUrl = file.url ? `${config.s3_url}${file.url}` : null;
			setPreviewImage(fileUrl || file.preview);
			setPdfPreviewOpen(true); // Open PDF preview modal
		} else {
			// For non-PDF files, generate a preview if necessary
			if (!file.url && !file.preview && file.originFileObj) {
				file.preview = await getBase64(file.originFileObj);
			}
			setPreviewImage(file.url || file.preview);
			setPreviewOpen(true); // Open image preview modal
			setPreviewTitle(
				file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
			);
		}
	};

	const handleClinicalDocumentChange = ({ fileList: newFileList }) => {
		const updatedFileList = newFileList.map((file) => {
			if (file.status === 'error') {
				return { ...file, status: 'done' };
			}
			return file;
		});
		setClinicalDocumentFileList(updatedFileList);
		setUpdatedClinicalDocumentFileList(updatedFileList);
		summaryForm.setFieldsValue({
			clinical_summary: '',
		});
		setFormData({
			...formData,
			clinical_summary: '',
		});
		setSummary('');
		summaryForm.validateFields(['clinical_document']);
	};

	const uploadButton = (
		<Button
			style={{
				border: 0,
				background: 'none',
				margin: '0',
				boxShadow: 'none',
			}}
		>
			<PlusOutlined style={{ color: '#000' }} />
			<div style={{ color: '#000' }}>Upload</div>
		</Button>
	);

	const handleRemoveClinicalDocuments = async (file) => {
		Modal.confirm({
			title: 'Confirm Deletion',
			content: 'Are you sure you want to delete this file?',
			okText: 'Yes',
			cancelText: 'No',
			cancelButtonProps: {
				// Add an icon to the Cancel button
				style: {
					backgroundColor: '#fff', // Red background for Cancel
					color: '#007299', // Text color
				},
			},
			okButtonProps: {
				style: {
					backgroundColor: '#007299',
					borderColor: '#007299',
					color: '#fff',
				},
			},
			onOk: async () => {
				const updatedFileList = clinicalDocumentFileList.filter(
					(item) => item.uid !== file.uid,
				);
				const updatedFileListToDisplay =
					clinicalDocumentsToDisplay.filter(
						(item) => item.uid !== file.uid,
					);
				setClinicalDocumentFileList(updatedFileList);
				setUpdatedClinicalDocumentFileList(updatedFileList);
				setClinicalDocumentsToDisplay(updatedFileListToDisplay);
				form.validateFields(['clinical_document']);
				if (!file.originFileObj) {
					// setDeletedClinicalDocuments((prevFiles) => [
					// 	...prevFiles,
					// 	file,
					// ]);
				}
			},
			onCancel: () => {
				form.validateFields(['clinical_document']);
				console.log('Deletion cancelled');
			},
		});
	};

	// Function to generate a random alphanumeric string of given length
	const generateRandomAlphaNumeric = (length) => {
		const characters =
			'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		let result = '';
		for (let i = 0; i < length; i++) {
			result += characters.charAt(
				Math.floor(Math.random() * characters.length),
			);
		}
		return result;
	};

	// // Function to generate an ID with specified format
	// const generateCustomId = () => {
	// 	const randomPart = generateRandomAlphaNumeric(9); // First 9 characters alphanumeric
	// 	const timestampPart = moment().format('YYDDMMHHMMSSMS'); // Last 15 characters formatted as YYDDMMHHMMSSMS
	// 	const customId = randomPart + timestampPart;

	// 	return customId;
	// };

	// Generate a random 24-character hexadecimal ID
	const generateCustomId = () => {
		const characters = '0123456789abcdef';
		let result = '';
		for (let i = 0; i < 24; i++) {
			result += characters.charAt(
				Math.floor(Math.random() * characters.length),
			);
		}
		return result;
	};

	const updatePageContent = (title, id, content) => {
		if (id === null) {
			if (title === 'originalQuery') {
				setPageContent({
					...pageContent,
					originalQuery: content,
				});
			} else {
				setPageContent({
					...pageContent,
					[title]: [...pageContent[[title]], content],
				});
			}
		} else {
			const updatedPageContent = { ...pageContent };
			updatedPageContent[[title]][id] = content;
			setPageContent(updatedPageContent);
		}
		// setSummary(formData.clinical_summary);
		setClinicalSummaryTextLoading(false);
		setShowClinicalTextArea(false);
		setModalOpen([false, '', ' ']);
		setModalTextArea('');
		form.resetFields();
		document.getElementById('notification').classList.remove('d-none');
	};

	const handleAddOption = (index) => {
		setNewCheckBoxModal([true, index]);
		setNewOptionText('');
		newOptionForm.setFieldsValue({});
		newOptionForm.resetFields();
	};

	const handleNewCheckBoxModal = () => {
		// Create a new option object
		newOptionForm
			.validateFields()
			.then(() => {
				const newOption = {
					label: newOptionText,
					value: newOptionText,
				};

				if (
					newCheckBoxModal[1] !== null &&
					newCheckBoxModal[1] >= 0 &&
					newCheckBoxModal[1] < missingFields.length
				) {
					const updatedFields = [...missingFields];
					updatedFields[newCheckBoxModal[1]].options.push(newOption);
					setMissingFields(updatedFields);

					// Get the current form values
					const currentValues = missingFieldsForm.getFieldsValue();

					// Add the new option to the appropriate field and mark it as checked
					if (
						!currentValues[updatedFields[newCheckBoxModal[1]].name]
					) {
						currentValues[updatedFields[newCheckBoxModal[1]].name] =
							[];
					}
					currentValues[updatedFields[newCheckBoxModal[1]].name].push(
						newOptionText,
					);

					// Update the form with the new values
					missingFieldsForm.setFieldsValue(currentValues);
				}

				// Close the modal and reset the newOptionText state
				setNewCheckBoxModal([false, null]);
				setNewOptionText('');
				newOptionForm.setFieldsValue({});
				newOptionForm.resetFields();
			})
			.catch((info) => {
				console.log('Validate Failed:', info);
			});
	};

	const handleClinicalSummaryDoc = () => {
		const formData = new FormData();

		// // Append supportingDocs files
		// supportingFiles.forEach((file) => {
		// 	formData.append('supporting_docs', file.url?.originFileObj); // 'supportingDocs' will be the backend key
		// });

		// Append clinicalDocs files
		clinicalDocumentFileList.forEach((file) => {
			formData.append('clinical_docs', file.originFileObj); // 'clinicalDocs' will be the backend key
		});
		formData.append('supportingDocsSummary', supportingDocsSummary);
		// formData.append('state', state);
		// formData.append('provider', provider);
		// formData.append('analysis_id', id);
		// Log to check FormData contents
		// setLoading(true);
		setIsClinicalDocUploadFromCommon(true);
		analyseCoverage(formData);
	};

	const getBase64 = (file) =>
		new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = (error) => reject(error);
		});

	const handleClinicalDocsChange = ({ fileList: newFileList }) => {
		const updatedFileList = newFileList.map((file) => {
			if (file.status === 'error') {
				return { ...file, status: 'done' };
			}
			// file.preview = await getBase64(file.originFileObj);
			return file;
		});
		setClinicalDocumentFileList(updatedFileList);
		setUpdatedClinicalDocumentFileList(updatedFileList);
		clinicalDocsForm.validateFields(['clinical_docs']);
	};

	// Function to handle form submission
	const handleShazamClick = () => {
		setLoading(true); // Assuming you have setLoading function declared somewhere
		const newId = generateCustomId();
		setId(newId); // Update state with generated ID

		const formData = new FormData();
		// Append supportingDocs files
		supportingFiles.forEach((file) => {
			formData.append('supporting_docs', file.url?.originFileObj); // 'supportingDocs' will be the backend key
		});

		// Append clinicalDocs files
		clinicalDocumentFileList.forEach((file) => {
			formData.append('clinical_docs', file.originFileObj); // 'clinicalDocs' will be the backend key
		});
		formData.append('clinicalSummary', summary);
		formData.append('state', state);
		formData.append('provider', provider);
		formData.append('analysis_id', newId);
		formData.append('model_type', selectedModel);
		// Log to check FormData contents
		setIsUploadClinicalDoc(true);
		setIsClinicalDocUploadFromCommon(true);
		setLoading(true);
		analyseCoverage(formData);
	};

	useEffect(() => {
		if (showAnalysisData) {
			document.getElementById('getQust').classList.add('bottom-100');
			document.getElementById('getAns').classList.add('top-0');
			document.getElementById('getAns').classList.remove('top-100');
			document.getElementById('getAns')?.classList.remove('d-none');
		}
	}, [showAnalysisData]);

	useEffect(() => {
		if (missingFieldsModal && missingFieldsCardRef.current) {
			// ADD
			document.getElementById('getQust').classList.add('bottom-100');
			document.getElementById('getAns').classList.add('top-0');
			document.getElementById('getAns').classList.remove('top-100');
			document.getElementById('getAns')?.classList.remove('d-none');
			// ADD
			missingFieldsCardRef.current.scrollIntoView({ behavior: 'smooth' });
		}
	}, [missingFieldsModal]);

	useEffect(() => {
		if (analyseCoverageState.apiState === 'success') {
			//
			setClinicalSummaryTextLoading(false);
			setClinicalDocumentsToDisplay(updatedClinicalDocumentFileList);
			handleUploadCancel();
			setClinicalDocsLoading(false);
			setShowClinicalTextArea(false);
			setFeedbackId(analyseCoverageState.data.feedback_id);
			setSupportingDocsSummary(
				analyseCoverageState.data?.supportingDocsSummary,
			);
			setLastAnalysisData(analyseCoverageState.data);
			if (isClinicalDocUploadFromCommon) {
				setSummary(analyseCoverageState.data['original_query'] ?? '');
			}
			setPageContent({
				...pageContent,
				originalQuery:
					analyseCoverageState.data['original_query'] ?? '',
				pastHistory: analyseCoverageState.data['Past History'] ?? [],
				presentComplaint:
					analyseCoverageState.data['Present Complaint'] ?? [],
				recommendedProcedure:
					analyseCoverageState.data['Suggested Treatment'] ?? [],
				medicalCoverage: [
					analyseCoverageState.data['Medicare Evaluation']
						? analyseCoverageState.data['Medicare Evaluation'][
								'Coverage'
						  ]
						: 'No',
					analyseCoverageState.data['Medicare Evaluation']
						? analyseCoverageState.data['Medicare Evaluation'][
								'Rationale'
						  ]
						: '',
					analyseCoverageState.data['Medicare Evaluation']
						? analyseCoverageState.data['Medicare Evaluation'][
								'reference'
						  ]
						: null,
				],
				missing_points_for_coverage:
					analyseCoverageState.data.missing_points_for_coverage ?? [],
				ncd_reference:
					analyseCoverageState.data['NCD References'] ?? '',
				retired_message:
					analyseCoverageState.data.retired_message ?? '',
				is_retired: analyseCoverageState.data.is_retired ?? 0,
			});

			setAnalysisCompleted('success');
			analyseCoverageReset();
			// setLoading(false);
			setIsUploadClinicalDoc(false);
			setIsClinicalDocUploadFromCommon(false);

			if (
				analyseCoverageState.data.hasOwnProperty('is_fields_missing') &&
				analyseCoverageState.data.is_fields_missing &&
				analyseCoverageState.data.hasOwnProperty('missing_fields')
			) {
				if (analyseCoverageState.data.missing_fields.length > 0) {
					setMissingFields(
						analyseCoverageState.data.missing_fields ?? [],
					);
					setMissingFieldInstructions(
						analyseCoverageState.data.missing_field_instructions ??
							[],
					);
					setMissingFieldTitle(
						analyseCoverageState.data.missing_field_title ?? '',
					);
					setMissingFieldsModal(true);
					setIsMissingFieldsThere(true);
				}
			} else {
				setShowAnalysisData(true);
				setIsMissingFieldsThere(false);
			}
		}

		if (analyseCoverageState.apiState === 'error') {
			// setLoading(false);
			setIsClinicalDocUploadFromCommon(false);
			// setShowClinicalTextArea(false);
			setAnalysisCompleted('error');
			setIsMissingFieldsThere(false);
			notification.error({
				message:
					'Hey, we are facing high traffic. Please check back in few minutes.',
			});
			analyseCoverageReset();
		}
	}, [analyseCoverageState]);

	useEffect(() => {
		if (getAnalysisState.apiState === 'success') {
			setFeedbackId(getAnalysisState.data.coverage_feedback_response._id);
			setLastAnalysisData(
				getAnalysisState.data?.coverage_feedback_response,
			);
			setPageContent({
				...pageContent,
				originalQuery: summary ?? '',
				pastHistory:
					getAnalysisState.data.coverage_feedback_response[
						'Past History'
					] ?? [],
				presentComplaint:
					getAnalysisState.data.coverage_feedback_response[
						'Present Complaint'
					] ?? [],
				recommendedProcedure:
					getAnalysisState.data.coverage_feedback_response[
						'Suggested Treatment'
					] ?? [],
				medicalCoverage: [
					getAnalysisState.data.coverage_feedback_response[
						'Medicare Evaluation'
					]
						? getAnalysisState.data.coverage_feedback_response[
								'Medicare Evaluation'
						  ]['Coverage']
						: 'No',
					getAnalysisState.data.coverage_feedback_response[
						'Medicare Evaluation'
					]
						? getAnalysisState.data.coverage_feedback_response[
								'Medicare Evaluation'
						  ]['Rationale']
						: '',
					getAnalysisState.data.coverage_feedback_response[
						'Medicare Evaluation'
					]
						? getAnalysisState.data.coverage_feedback_response[
								'Medicare Evaluation'
						  ]['reference']
						: null,
				],
				missing_points_for_coverage:
					getAnalysisState.data.coverage_feedback_response
						.missing_points_for_coverage ?? [],
				status: getAnalysisState.data.coverage_feedback_response.status,
				ncd_reference:
					getAnalysisState.data.coverage_feedback_response[
						'NCD References'
					] ?? '',
				retired_message:
					getAnalysisState.data.coverage_feedback_response
						.retired_message ?? '',
				is_retired:
					getAnalysisState.data.coverage_feedback_response
						.is_retired ?? 0,
			});
			setLoading(false);
			setCoverageLoading(false);
			setLooksGoodLoading(false);
			setModalOpen([false, '', '']);
			document.getElementById('getQust').classList.add('bottom-100');
			document.getElementById('getAns').classList.add('top-0');
			document.getElementById('getAns').classList.remove('top-100');
			document.getElementById('getAns')?.classList.remove('d-none');
		}

		if (getAnalysisState.apiState === 'error') {
			setLoading(false);
			notification.error({
				message:
					'Hey, we are facing high traffic. Please check back in few minutes.',
			});
		}
		getAnalysisReset();
	}, [getAnalysisState]);

	useEffect(() => {
		if (reviseCoverageState.apiState === 'success') {
			setFeedbackId(reviseCoverageState.data.feedback_id);
			setLastAnalysisData(reviseCoverageState.data);
			setPageContent({
				...pageContent,
				originalQuery: reviseCoverageState.data['original_query'] ?? '',
				pastHistory: reviseCoverageState.data['Past History'] ?? [],
				presentComplaint:
					reviseCoverageState.data['Present Complaint'] ?? [],
				recommendedProcedure:
					reviseCoverageState.data['Suggested Treatment'] ?? [],
				medicalCoverage: [
					reviseCoverageState.data['Medicare Evaluation']
						? reviseCoverageState.data['Medicare Evaluation'][
								'Coverage'
						  ]
						: 'No',
					reviseCoverageState.data['Medicare Evaluation']
						? reviseCoverageState.data['Medicare Evaluation'][
								'Rationale'
						  ]
						: '',
					reviseCoverageState.data['Medicare Evaluation']
						? reviseCoverageState.data['Medicare Evaluation'][
								'reference'
						  ]
						: null,
				],
				missing_points_for_coverage:
					reviseCoverageState.data.missing_points_for_coverage ?? [],
				status: reviseCoverageState.data.status,
				ncd_reference:reviseCoverageState.data[
					'NCD References'
					] ?? '',
				retired_message:
				reviseCoverageState.data.retired_message ?? '',
				is_retired:
				reviseCoverageState.data.is_retired ?? 0,

			});
			setAnalysisCompleted('success');
			if (
				reviseCoverageState.data.hasOwnProperty('is_fields_missing') &&
				reviseCoverageState.data.is_fields_missing &&
				reviseCoverageState.data.hasOwnProperty('missing_fields')
			) {
				if (reviseCoverageState.data.missing_fields.length > 0) {
					setMissingFields(
						reviseCoverageState.data.missing_fields ?? [],
					);
					setMissingFieldInstructions(
						reviseCoverageState.data.missing_field_instructions ??
							[],
					);
					setMissingFieldTitle(
						reviseCoverageState.data.missing_field_title ?? '',
					);
					setMissingFieldsModal(true);
					setIsMissingFieldsThere(true);
				}
			} else {
				setShowAnalysisData(true);
				setIsMissingFieldsThere(false);
			}
			reviseCoverageReset();
		}
		if (reviseCoverageState.apiState === 'error') {
			setAnalysisCompleted('error');
			reviseCoverageReset();
			notification.error({
				message:
					'Hey, we are facing high traffic. Please check back in few minutes.',
			});
			document.getElementById('notification')?.classList.remove('d-none');
			document.getElementById('getAns')?.classList.remove('d-none');
		}
	}, [reviseCoverageState]);

	useEffect(() => {
		if (sendFeedbackState.apiState === 'success') {
			sendFeedbackReset();
			if (sendFeedbackState.data === 'negative')
				setThanksModal([true, 'Thanks for making us Better!']);
			else
				setThanksModal([true, 'Case has been analysed and confirmed!']);
			if (callGetAnalysisAPiBtn) {
				getAnalysis({ feedback_id: feedbackId });
				setCallGetAnalysisAPiBtn(true);
			} else {
				setCoverageLoading(false);
				setLooksGoodLoading(false);
				setModalOpen([false, '', '']);
			}
		} else if (sendFeedbackState.apiState === 'error') {
			sendFeedbackReset();
			setCallGetAnalysisAPiBtn(true);
			setCoverageLoading(false);
			setLooksGoodLoading(false);
		}
	}, [sendFeedbackState]);

	useEffect(() => {
		document.getElementById('getQust').classList.remove('bottom-100');
		document.getElementById('getAns').classList.remove('top-0');
		document.getElementById('getAns').classList.add('top-100');
		document.getElementById('getAns')?.classList.add('d-none');
		getStateDropdown();
		summaryForm.setFieldsValue({
			clinical_category: 'clinical_text',
		});
	}, []);

	// Open the modal and set a timer to automatically close it after 3 seconds
	useEffect(() => {
		let timer;
		if (thanksModal) {
			timer = setTimeout(() => {
				setThanksModal([false, '']);
			}, 5000);
		}

		// Clear the timer if the component unmounts or showThanksModal changes
		return () => clearTimeout(timer);
	}, [thanksModal]);

	return (
		<>
			<XContainer fluid>
				<div className="marginTopMobile "></div>
				<Affix id="notification" className="d-none" offsetTop={10}>
					<div className="marginBottomMobile"></div>
					<div
						className="mb-3"
						style={{
							backgroundColor: 'white',
							borderRadius: '20px',
							zIndex: '1111110',
						}}
					>
						<XNotificationBar style={{ zIndex: '22222' }}>
							Clinical Summary has been changed !! Click to{' '}
							<XButtonReload
								type="button"
								style={{ padding: '18px' }}
								className="refreshBtn"
								onClick={() => {
									setLoading(true);
									document
										.getElementById('notification')
										?.classList.add('d-none');

									reviseCoverageReset();
									// Update lastAnalysisData with the latest pageContent values
									const updatedLastAnalysisData = {
										...lastAnalysisData, // Keep all the existing keys and values intact
										'Past History': pageContent.pastHistory, // Update pastHistory
										'Present Complaint':
											pageContent.presentComplaint, // Update presentComplaint
										'Suggested Treatment':
											pageContent.recommendedProcedure, // Update recommendedProcedure
										'Medicare Evaluation': {
											...lastAnalysisData[
												'Medicare Evaluation'
											],
											Coverage:
												pageContent.medicalCoverage[0], // Update medicalCoverage fields
											Rationale:
												pageContent.medicalCoverage[1],
											reference:
												pageContent.medicalCoverage[2],
										},
										original_query:
											pageContent.originalQuery, // Update original_query
										past_history: pageContent.pastHistory, // Update past_history in lastAnalysisData
										present_complaint:
											pageContent.presentComplaint, // Update present_complaint in lastAnalysisData
										status: pageContent.status, // Update status in lastAnalysisData
										missing_points_for_coverage:
											pageContent.missing_points_for_coverage, // Update missing_points_for_coverage
										// Add other updates if necessary, or keep them unchanged
									};
									reviseCoverage({
										// case_id: patientData._id,
										analysis_id: id,
										feedbackId: feedbackId,
										clinicalHistory:
											pageContent.pastHistory,
										presentComplaint:
											pageContent.presentComplaint,
										recommendedProcedure:
											pageContent.recommendedProcedure,
										medicalCoverage:
											pageContent.medicalCoverage,
										state: state,
										provider: provider,
										last_analysis_data:
											updatedLastAnalysisData,
										supportingDocsSummary:
											supportingDocsSummary,
									});
								}}
							>
								Reanalyse it !!
							</XButtonReload>
							<XButtonCloseBar
								type="button"
								className="closeBar mt-3"
							>
								<CloseOutlined
									onClick={() => {
										document
											.getElementById('notification')
											?.classList.add('d-none');
									}}
									style={{ fontSize: '20px' }}
								/>
							</XButtonCloseBar>
						</XNotificationBar>
					</div>
					<div className="marginNone"></div>
				</Affix>
			</XContainer>
			<>
				<Col lg={24} xl={24} xs={0} md={0}>
					<Header headerTag="AIPA" />
				</Col>
				<Col lg={0} xl={0} xs={24} md={24}>
					<HeaderFile activeNav="aipa" />
				</Col>
			</>

			<XContainer className="slideBox" fluid>
				{loading && (
					<AnalysisLoader
						analysisId={id}
						isOpenAnalysis={'true'}
						analysisCompleted={analysisCompleted}
						setAnalysisCompleted={setAnalysisCompleted}
						setLoading={setLoading}
						loading={loading}
						isMissingFieldsThere={isMissingFieldsThere}
						setIsMissingFieldsThere={setIsMissingFieldsThere}
					/>
				)}

				<div id="getQust" className="">
					<Row>
						<Col
							xs={{ span: 12, offset: 6 }}
							lg={{ span: 5, offset: 9 }}
							className="text-center"
						>
							<XLottieMargin>
								<XLottie
									animationData={LoginAnimation}
									loop={true}
								/>
							</XLottieMargin>
						</Col>
					</Row>
					<XForm
						form={summaryForm}
						name="loginForm"
						layout="vertical"
						autoComplete="off"
						onFinish={handleShazamClick}
					>
						<Row gutter={[15, 15]}>
							<Col
								xs={{ span: 24, offset: 0 }}
								lg={{ span: 7, offset: 8 }}
							>
								<Title>RevMaxx</Title>
							</Col>
							<Col
								xs={{ span: 24, offset: 0 }}
								lg={{ span: 20, offset: 2 }}
								className="mb-2"
							>
								<XPara1 className="text-center">
									RevMaxx utilizes comprehensive standardized
									clinical notes to generate recommended
									best-fit diagnostic ICD-10, procedural
									CPT/HCPCS or drug NDC codes. It also
									provides insights into Insurance coverage.
								</XPara1>
							</Col>
							{/* start */}
							{/* Clinical Summary */}
							<Col xs={24}>
								<AipaCard className="mb-3">
									<Row gutter={[15, 15]}>
										<Col xs={24}>
											<XForm.Item
												className="addCaseLabel mb-1"
												name="clinical_category"
												rules={[
													{
														required: true,
														message:
															'Please select option!',
													},
												]}
											>
												<XRadio.Group
													defaultValue={
														clinicalSelectedOption
													}
													onChange={(e) => {
														handleInputChange(
															e,
															formData,
															setFormData,
														);
														if (
															e.target.value ===
															'clinical_text'
														) {
															setClinicalSelectedOption(
																'clinical_text',
															);
														} else if (
															e.target.value ===
															'clinical_document'
														) {
															setClinicalSelectedOption(
																'clinical_document',
															);
															// } else if (
															// 	e.target.value ===
															// 	'dictate_audio'
															// ) {
															// 	setClinicalSelectedOption(
															// 		'dictate_audio',
															// 	);
														}
													}}
													className="d-block"
												>
													<XRadio
														className="pb-2"
														value={'clinical_text'}
													>
														Enter Clinical Summary
													</XRadio>
													<XRadio
														className="pb-2"
														value={
															'clinical_document'
														}
													>
														Upload Clinical Summary
													</XRadio>
													{/* <XRadio
														className="pb-2"
														value={'dictate_audio'}
													>
														Dictate
													</XRadio> */}
												</XRadio.Group>
											</XForm.Item>
										</Col>
									</Row>
								</AipaCard>
								<Row gutter={[15, 15]}>
									{clinicalSelectedOption ===
										'clinical_text' && (
										<Col xs={24}>
											<XForm.Item
												className="addCaseLabel mb-0"
												name="clinical_summary"
												rules={[
													{
														required: true,
														message:
															'Please enter clinical summary',
													},
												]}
											>
												<TextArea
													className="inputBg inputAipa"
													name="clinical_summary"
													showCount
													style={{
														marginBottom: 24,
													}}
													onChange={(e) => {
														handleInputChange(
															e,
															formData,
															setFormData,
														);
														setSummary(
															e.target.value,
														);
														setClinicalDocumentFileList(
															[],
														);
														setUpdatedClinicalDocumentFileList(
															[],
														);
													}}
													autoSize={{
														minRows: 5,
													}}
													placeholder="Enter Detailed Clinical Summary"
												/>
											</XForm.Item>
										</Col>
									)}

									{clinicalSelectedOption ===
										'clinical_document' && (
										<Col xs={24} md={24} lg={24}>
											<>
												<XForm.Item
													className="addCaseLabe"
													name="clinical_document"
													rules={[
														{
															required: true,
															validator: (
																_,
																value,
															) => {
																if (
																	clinicalDocumentFileList.length ===
																	0
																) {
																	return Promise.reject(
																		new Error(
																			'Please upload Clinical Document!',
																		),
																	);
																}
																return Promise.resolve();
															},
														},
													]}
												>
													<XuploadAddCase
														action={null}
														multiple={false}
														maxCount={1}
														showUploadList={{
															showPreviewIcon: true,
															showRemoveIcon: true,
														}}
														className="supporting_files"
														listType="picture-card"
														fileList={
															clinicalDocumentFileList
														}
														onPreview={
															handlePreviewClinicalSummary
														}
														onChange={
															handleClinicalDocumentChange
														}
														onRemove={(file) => {
															handleRemoveClinicalDocuments(
																file,
															);
															return false; // Prevent default removal behavior to avoid triggering onChange
														}}
														accept=".pdf"
														beforeUpload={(
															file,
														) => {
															const isJPEG =
																file.type ===
																'image/jpeg';
															const isJPG =
																file.type ===
																'image/jpg';
															const isPNG =
																file.type ===
																'image/png';
															const isGIF =
																file.type ===
																'image/gif';
															const isVideo =
																file.type.startsWith(
																	'video/',
																);
															const isAudio =
																file.type.startsWith(
																	'audio/',
																);

															const isLt10M =
																file.size /
																	1024 /
																	1024 <
																10;

															if (!isLt10M) {
																notification.error(
																	{
																		message:
																			'File Size Exceeded',
																		description: `The file ${file.name} exceeds the maximum allowed size of 10MB.`,
																	},
																);
															}
															if (
																isGIF ||
																isVideo ||
																isAudio ||
																isJPEG ||
																isJPG ||
																isPNG
															) {
																notification.error(
																	{
																		message:
																			'File Type Error',
																		description: `GIF, video, image and audio files are not allowed.`,
																	},
																);
															}

															return (
																isLt10M &&
																!isGIF &&
																!isVideo &&
																!isAudio &&
																!isJPEG &&
																!isJPG &&
																!isPNG
															);
														}}
													>
														{clinicalDocumentFileList.length >=
														1
															? null
															: uploadButton}
													</XuploadAddCase>
												</XForm.Item>
											</>
										</Col>
									)}

									{/* {clinicalSelectedOption ===
										'dictate_audio' && (
										<Col xs={24} md={24} lg={24}>
											<AipaAudioCard>
												<div className="timeTitle">
													00.00.00
												</div>
												<img
													className="img-fluid"
													src="/images/audio-graph.svg"
													alt=""
												/>
												<div className="w-100 text-center mt-3">
													<AipaAudioBtn
														size="large"
														icon={<AudioOutlined />}
													/>
												</div>
											</AipaAudioCard>
										</Col>
									)} */}
								</Row>
							</Col>
							{/* Clinical Summary Ends */}
							<Col xs={{ span: 24 }} lg={{ span: 12 }}>
								<XForm.Item
									name="state"
									label="State"
									rules={[
										{
											required: true,
											message: 'Please select State',
										},
									]}
									className="mb-3"
								>
									<XSelect
										size="large"
										placeholder="Select State"
										name="state"
										showSearch={true}
										onSearch={(search) => {
											if (search.length >= 3) {
												getStateDropdown({
													search,
												});
											} else if (search.length === 0) {
												getStateDropdown();
											}
										}}
										filterOption={filterByLabel}
										options={
											getStateDropdownState.apiState ===
												'success' &&
											getStateDropdownState.data
												.all_states?.length > 0 &&
											getStateDropdownState.data.all_states.map(
												(itm) => {
													return {
														label: itm.state,
														value: itm.state,
														providers:
															itm.providers,
													};
												},
											)
										}
										onSelect={(value, options) => {
											setState(value);
											summaryForm.setFieldValue(
												'insurance_company',
												null,
											);
											setInsuranceCompanies(
												options.providers,
											);
										}}
									/>
								</XForm.Item>
							</Col>
							<Col xs={{ span: 24 }} lg={{ span: 12 }}>
								<XForm.Item
									name="insurance_company"
									label="Insurance Company"
								>
									<XSelect
										size="large"
										placeholder="Select Insurance Company"
										name="insurance_company"
										showSearch={true}
										filterOption={filterByLabel}
										options={
											insuranceCompanies.length > 0 &&
											insuranceCompanies.map((itm) => {
												return {
													label: itm.name,
													value: itm.name,
												};
											})
										}
										onSelect={(value) => {
											setProvider(value);
										}}
									/>
								</XForm.Item>
							</Col>
							<Col xs={{ span: 24 }} lg={{ span: 12 }}>
								<XForm.Item
									name="model_type"
									label="LLM Model"
								>
									<XSelect
										size="large"
										placeholder="Select LLM Model"
										name="model_type"
										showSearch={true}
										filterOption={filterByLabel}
										options={modelTypes}
										onSelect={(value) => {
											setSelectedModel(value);
										}}
										defaultValue=""
									/>
								</XForm.Item>
							</Col>
							<Col xs={24} className="text-center mt-3">
								<Button htmlType="submit" type="primary">
									Analyze !{/* Shazaam ! */}
								</Button>
							</Col>
						</Row>
					</XForm>
				</div>
				<div id="getAns" className="slideUp top-100 mt-4 d-none">
					{appealLetterLoading && (
						<XLottieOverlay>
							<XLottie
								animationData={AppealLoading}
								loop={true}
							/>
						</XLottieOverlay>
					)}
					{showAppealLetterPreview ? (
						<>
							<Row>
								<AppealLetter
									aipa={true}
									appealLetterContent={appealLetterContent}
									appealLetterLoading={appealLetterLoading}
									showAppealLetterPreview={
										showAppealLetterPreview
									}
									setShowAppealLetterPreview={
										setShowAppealLetterPreview
									}
									setAppealLetterLoading={
										setAppealLetterLoading
									}
									previewAppealLetter={previewAppealLetter}
									id={id}
								/>
							</Row>
						</>
					) : (
						<Row gutter={(0, 30)}>
							<Col xs={24} sm={24} md={24} lg={24} xl={24}>
								{/* new component start */}
								<CaseOperations
									aipa={true}
									previewMode={false}
									matchGender={''}
									loading={loading}
									summary={summary}
									state={state}
									provider={provider}
									setSummary={setSummary}
									handleRemoveClinicalDocuments={
										handleRemoveClinicalDocuments
									}
									handleClinicalSummaryDoc={
										handleClinicalSummaryDoc
									}
									isOpenAnalysis={'true'}
									patientData={''}
									mainDataLoading={''}
									handleClinicalDocsChange={
										handleClinicalDocsChange
									}
									clinicalDocumentFileList={
										clinicalDocumentFileList
									}
									clinicalDocsForm={clinicalDocsForm}
									handleUploadCancel={handleUploadCancel}
									clinicalDocsLoading={clinicalDocsLoading}
									setIsClinicalUploadModalOpen={
										setIsClinicalUploadModalOpen
									}
									isClinicalUploadModalOpen={
										isClinicalUploadModalOpen
									}
									setPreviewImage={setPreviewImage}
									previewImage={previewImage}
									setPreviewTitle={setPreviewTitle}
									previewTitle={previewTitle}
									setPdfPreviewOpen={setPdfPreviewOpen}
									pdfPreviewOpen={pdfPreviewOpen}
									documentsToDisplay={supportingFiles}
									supportingDocsSummary={
										supportingDocsSummary
									}
									clinicalSummaryTextLoading={
										clinicalSummaryTextLoading
									}
									setClinicalSummaryTextLoading={
										setClinicalSummaryTextLoading
									}
									setShowClinicalTextArea={
										setShowClinicalTextArea
									}
									showClinicalTextArea={showClinicalTextArea}
									setFormData={setFormData}
									formData={formData}
									id={id}
									setPageContent={setPageContent}
									pageContent={pageContent}
									clinicalDocumentsToDisplay={
										clinicalDocumentsToDisplay
									}
									feedbackId={feedbackId}
									reviseCoverage={reviseCoverage}
									lastAnalysisData={lastAnalysisData}
									setLoading={setLoading}
									getBase64={getBase64}
									setClinicalDocsLoading={
										setClinicalDocsLoading
									}
									setSubmitClinicalDocs={
										setSubmitClinicalDocs
									}
									setUpdatedClinicalDocumentFileList={''}
									form={form}
									setModalTextArea={setModalTextArea}
									setModalOpen={setModalOpen}
									modalOpen={modalOpen}
									sendFeedback={sendFeedback}
									sendFeedbackState={sendFeedbackState}
									modalTextArea={modalTextArea}
									updatePageContent={updatePageContent}
									missingFieldsForm={missingFieldsForm}
									missingFieldsCardRef={missingFieldsCardRef}
									handleAddOption={handleAddOption}
									missingFields={missingFields}
									missingFieldInstructions={
										missingFieldInstructions
									}
									setMissingFieldsModal={
										setMissingFieldsModal
									}
									setMissingFieldInstructions={
										setMissingFieldInstructions
									}
									setMissingFields={setMissingFields}
									missingFieldTitle={missingFieldTitle}
									missingFieldsModal={missingFieldsModal}
								/>
								{/* new component end */}

								{!missingFieldsModal ? (
									<>
										<div className="showMobile">
											<Row
												gutter={(15, 15)}
												className="mt-4"
											>
												<Col xs={12}>
													<XButtonConfirm
														className="w-100"
														type="primary"
														size="large"
														shape="round"
														style={{
															background: '#fff',
														}}
														icon={
															<img
																className="rotateButton"
																src="/images/like-icon.svg"
																alt=""
															/>
														}
														onClick={() => {
															form.setFieldsValue(
																{
																	modal_text_area:
																		pageContent.medicalCoverage
																			? pageContent
																					.medicalCoverage[1]
																			: '',
																	medicare_flag:
																		pageContent.medicalCoverage
																			? pageContent
																					.medicalCoverage[0]
																			: '',
																},
															);
															setModalTextArea(
																pageContent
																	.medicalCoverage[1],
															);
															setModalOpen([
																true,
																`Edit Medicare Coverage`,
																pageContent
																	.medicalCoverage[1],
																1,
																'feedbackSummary',
															]);
															setCallGetAnalysisAPiBtn(
																true,
															);
														}}
													>
														Refine
													</XButtonConfirm>
												</Col>
												<Col xs={12}>
													<XButtonConfirm
														className="w-100"
														type="primary"
														size="large"
														shape="round"
														style={{
															background: '#fff',
														}}
														icon={
															<img
																src="/images/like-icon.svg"
																alt=""
															/>
														}
														loading={
															LooksGoodLoading
														}
														onClick={() => {
															setLooksGoodLoading(
																true,
															);
															setCallGetAnalysisAPiBtn(
																true,
															);
															sendFeedback({
																feedback_id:
																	feedbackId,
																feedback:
																	'positive',
																status: 'approved',
																response:
																	pageContent.medicalCoverage,
															});
														}}
													>
														Looks Good
													</XButtonConfirm>
												</Col>
												{pageContent
													.medicalCoverage[0] ===
													'Yes' && (
													<>
														<Col
															xs={24}
															className="mt-4"
														>
															<XButtonConfirm
																className="btnActive w-100"
																onClick={() => {
																	setAppealLetterLoading(
																		true,
																	);
																	// setLoading(true);
																	previewAppealLetter(
																		'pre',
																		true,
																	);
																}}
																type="primary"
																shape="round"
																// icon={
																// 	<img
																// 		src="/images/check 1.svg"
																// 		alt=""
																// 	/>
																// }
																size="large"
															>
																Generate Appeal
																Letter
															</XButtonConfirm>
														</Col>
													</>
												)}
											</Row>
										</div>
										<div className="showDesktop">
											<Row className="text-end">
												<Col
													xs={24}
													lg={12}
													className="mt-4"
												>
													<Space
														style={{
															width: '100%',
														}}
													>
														<XButtonConfirm
															className="mb-2 mb-md-0 mb-sm-0"
															type="primary"
															size="large"
															shape="round"
															style={{
																background:
																	'#fff',
															}}
															icon={
																<img
																	className="rotateButton"
																	src="/images/like-icon.svg"
																	alt=""
																/>
															}
															onClick={() => {
																form.setFieldsValue(
																	{
																		modal_text_area:
																			pageContent.medicalCoverage
																				? pageContent
																						.medicalCoverage[1]
																				: '',
																		medicare_flag:
																			pageContent.medicalCoverage
																				? pageContent
																						.medicalCoverage[0]
																				: '',
																	},
																);
																setModalTextArea(
																	pageContent
																		.medicalCoverage[1],
																);
																setModalOpen([
																	true,
																	`Edit Medicare Coverage`,
																	pageContent
																		.medicalCoverage[1],
																	1,
																	'feedbackSummary',
																]);
																setCallGetAnalysisAPiBtn(
																	true,
																);
															}}
														>
															Refine
														</XButtonConfirm>
														<XButtonConfirm
															className="mb-2 mb-md-0 mb-sm-0"
															type="primary"
															size="large"
															shape="round"
															style={{
																background:
																	'#fff',
															}}
															icon={
																<img
																	src="/images/like-icon.svg"
																	alt=""
																/>
															}
															loading={
																LooksGoodLoading
															}
															onClick={() => {
																setLooksGoodLoading(
																	true,
																);
																setCallGetAnalysisAPiBtn(
																	true,
																);
																sendFeedback({
																	feedback_id:
																		feedbackId,
																	feedback:
																		'positive',
																	status: 'approved',
																	response:
																		pageContent.medicalCoverage,
																});
															}}
														>
															Looks Good
														</XButtonConfirm>
													</Space>
												</Col>
												{pageContent
													.medicalCoverage[0] ===
													'Yes' && (
													<>
														<Col
															xs={24}
															lg={12}
															className="mt-4 text-md-end"
														>
															<XButtonConfirm
																onClick={() => {
																	setAppealLetterLoading(
																		true,
																	);
																	// setLoading(true);
																	previewAppealLetter(
																		'pre',
																		true,
																	);
																}}
																type="primary"
																shape="round"
																// icon={
																// 	<img
																// 		src="/images/check 1.svg"
																// 		alt=""
																// 	/>
																// }
																size="large"
																className="btnActive"
															>
																Generate Appeal
																Letter
															</XButtonConfirm>
														</Col>
													</>
												)}
											</Row>
										</div>
									</>
								) : (
									<></>
								)}
							</Col>
						</Row>
					)}
				</div>
			</XContainer>

			<XModal
				centered
				open={thanksModal[0]}
				closable={false} // Hide the close icon
				// onOk={() => setThanksModal([false, ''])}
				// onCancel={() => {
				// 	setThanksModal([false, '']);
				// }}
				className="modalButton"
				okText="Submit"
				footer={null}
			>
				<Row
					style={{
						display: 'flex',
						justifyContent: 'center',
					}}
					gutter={(15, 0)}
					className="mt-2"
				>
					<Col xs={24} lg={18}>
						<XLottieMargin>
							<XLottie animationData={Thanks} loop={true} />
						</XLottieMargin>

						<XPara1
							style={{ textAlign: 'center' }}
							className="mt-0"
						>
							{thanksModal[1]}
						</XPara1>
					</Col>
				</Row>
			</XModal>

			{/* Modal for Missing Fields */}
			<XModal
				title={
					<>
						{/* <EditOutlined /> */}
						<XModalTitle className="ms-2">
							Additional Information Required
						</XModalTitle>
						{missingFieldTitle && (
							<XModalSubtitle className="ms-2 mt-2">
								{missingFieldTitle}
							</XModalSubtitle>
						)}
						<XDivider dashed className="mt-3" />
					</>
				}
				centered
				// open={missingFieldsModal}
				open={''}
				onOk={() => {
					missingFieldsForm
						.validateFields()
						.then((values) => {
							setLoading(true);
							reviseCoverageReset();
							reviseCoverage({
								feedbackId: feedbackId,
								clinicalHistory: pageContent.pastHistory,
								presentComplaint: pageContent.presentComplaint,
								recommendedProcedure:
									pageContent.recommendedProcedure,
								medicalCoverage: pageContent.medicalCoverage,
								state: state,
								provider: provider,
								missing_fields: values,
								last_analysis_data: lastAnalysisData,
								analysis_id: id,
							});

							missingFieldsForm.resetFields();
							setMissingFields([]);
							setMissingFieldInstructions([]);
							setMissingFieldsModal(false);
						})
						.catch((error) => {
							return;
						});
				}}
				onCancel={() => {
					missingFieldsForm.resetFields();
					setMissingFields([]);
					setMissingFieldInstructions([]);
					setMissingFieldsModal(false);
				}}
				className="modalButton"
				width={900}
				okText="Submit"
				style={{
					padding: '40px',
					borderRadius: '5px !important',
					'ant-modal-content': {
						padding: '30px !important',
						borderRadius: '5px !important',
					},
				}}
			>
				<XForm
					form={missingFieldsForm}
					name="groupForm"
					layout="vertical"
					autoComplete="off"
				>
					<Row gutter={(15, 0)} className="mt-4">
						{missingFieldInstructions.length > 0 && (
							<Col xs={24}>
								<XList
									className="mobInstructionsData"
									size="small"
									header={<div>Instructions</div>}
									bordered
									dataSource={missingFieldInstructions}
									renderItem={(item, index) => (
										<List.Item>
											<span className="mobInstructionsNum">
												<XCircle>{index + 1}</XCircle>
											</span>
											{item}
										</List.Item>
									)}
								/>
								<br />
							</Col>
						)}

						{missingFields.map((item, index) => {
							if (item.type == 'textarea') {
								return (
									<Col xs={24}>
										<XForm.Item
											label={
												<XLabel>{item.label}</XLabel>
											}
											name={item.name}
											rules={[
												item.hasOwnProperty(
													'required',
												) &&
													item.required && {
														required: true,
														message:
															item.required_error_message ??
															'Field is required',
													},
												item.hasOwnProperty('regex') &&
													item.regex && {
														validator: (
															rule,
															value,
														) => {
															let regex =
																new RegExp(
																	item.regex.slice(
																		1,
																		-1,
																	),
																);
															if (
																!regex.test(
																	value,
																)
															)
																return Promise.reject(
																	new Error(
																		item.regex_error_message ??
																			'Invalid Data',
																	),
																);
															return Promise.resolve();
														},
													},
											]}
										>
											<TextArea
												rows={3}
												name={item.name}
												showCount
												className="textArea"
												placeholder="Enter"
											></TextArea>
										</XForm.Item>
									</Col>
								);
							} else if (item.type == 'input') {
								return (
									<Col xs={24}>
										<XForm.Item
											label={
												<XLabel>{item.label}</XLabel>
											}
											name={item.name}
											rules={[
												item.hasOwnProperty(
													'required',
												) &&
													item.required && {
														required: true,
														message:
															item.required_error_message ??
															'Field is required',
													},
												item.hasOwnProperty('regex') &&
													item.regex && {
														validator: (
															rule,
															value,
														) => {
															let regex =
																new RegExp(
																	item.regex.slice(
																		1,
																		-1,
																	),
																);
															if (
																!regex.test(
																	value,
																)
															)
																return Promise.reject(
																	new Error(
																		item.regex_error_message ??
																			'Invalid Data',
																	),
																);
															return Promise.resolve();
														},
													},
											]}
										>
											<Input
												size="large"
												name={item.name}
												placeholder="Enter"
											></Input>
										</XForm.Item>
									</Col>
								);
							} else if (item.type == 'checkbox') {
								return (
									<>
										<Col xs={24} key={index}>
											<XForm.Item
												name={item.name}
												rules={[
													item.required && {
														required: true,
														message:
															item.required_error_message ??
															'Field is required',
													},
												]}
											>
												<XCheckboxGroup
													name={item.name}
													style={{
														display: 'flex',
														flexDirection: 'column',
													}}
												>
													<XList
														className="normal-header"
														size="small"
														bordered
														header={
															<div
																style={{
																	display:
																		'flex',
																	justifyContent:
																		'space-between',
																	alignItems:
																		'center',
																}}
															>
																<XLabel>
																	{item.label}
																</XLabel>
																<XRoundButton
																	shape="circle"
																	icon={
																		<PlusOutlined />
																	}
																	onClick={() =>
																		handleAddOption(
																			index,
																		)
																	}
																/>
															</div>
														}
														dataSource={
															item.options
														}
														renderItem={(
															option,
															idx,
														) => (
															<List.Item>
																<Checkbox
																	value={
																		option.value
																	}
																>
																	{
																		option.label
																	}
																</Checkbox>
															</List.Item>
														)}
													/>
												</XCheckboxGroup>
											</XForm.Item>
										</Col>
									</>
								);
							} else if (item.type == 'radio') {
								return (
									<Col xs={24} key={index}>
										<XForm.Item
											name={item.name}
											rules={[
												item.required && {
													required: true,
													message:
														'Field is required',
												},
											]}
										>
											<Radio.Group
												style={{
													display: 'flex',
													flexDirection: 'column',
												}}
											>
												<XList
													className="normal-header"
													size="small"
													bordered
													header={
														<div
															style={{
																display: 'flex',
																justifyContent:
																	'space-between',
																alignItems:
																	'center',
															}}
														>
															<XLabel>
																{item.label}
															</XLabel>
														</div>
													}
													dataSource={item.options}
													renderItem={(
														option,
														idx,
													) => (
														<List.Item>
															<Radio
																value={
																	option.value
																}
															>
																{option.label}
															</Radio>
														</List.Item>
													)}
												/>
											</Radio.Group>
										</XForm.Item>
									</Col>
								);
							}
						})}
					</Row>
				</XForm>
			</XModal>

			{/* Modal for adding new option */}
			<XModal
				title="Add New Option"
				open={newCheckBoxModal[0]}
				onOk={handleNewCheckBoxModal}
				okText="Submit"
				onCancel={() => {
					setNewCheckBoxModal([false, null]);
					setNewOptionText('');
					newOptionForm.setFieldsValue({});
					newOptionForm.resetFields();
				}}
			>
				<XForm
					form={newOptionForm}
					name="groupForm"
					layout="vertical"
					autoComplete="off"
				>
					<XForm.Item
						name={'new-option'}
						rules={[
							{
								required: true,
								message: 'Please input option',
							},
						]}
					>
						<Input
							size="large"
							className="mt-3 mb-3"
							value={newOptionText}
							onChange={(e) => setNewOptionText(e.target.value)}
							placeholder="Enter new option text"
						/>
					</XForm.Item>
				</XForm>
			</XModal>
		</>
	);
};

const mapStateToProps = (state) => ({
	analyseCoverageState: state.analyseCoverage,
	reviseCoverageState: state.reviseCoverage,
	sendFeedbackState: state.sendFeedback,
	getStateDropdownState: state.getStateDropdown,
	getAnalysisState: state.getAnalysis,
	getAppealLetterState: state.getAppealLetter,
});

const mapDispatchToProps = (dispatch) => ({
	analyseCoverage: (params) => dispatch(analyseCoverageApi(params)),
	analyseCoverageReset: () => dispatch(analyseCoverageReset()),
	reviseCoverage: (params) => dispatch(reviseCoverageApi(params)),
	reviseCoverageReset: () => dispatch(reviseCoverageReset()),
	sendFeedback: (params) => dispatch(sendFeedbackApi(params)),
	sendFeedbackReset: () => dispatch(sendFeedbackReset()),
	getStateDropdown: () => dispatch(getStateDropdownApi()),
	getStateDropdownReset: () => dispatch(getStateDropdownReset()),
	getAnalysis: (params) => dispatch(getAnalysisApi(params)),
	getAnalysisReset: () => dispatch(getAnalysisReset()),
	getAppealLetter: (params) => dispatch(getAppealLetterApi(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Aipa);
